import React, {useMemo, useRef} from 'react';
import {licenseTypes, latinAlphabet} from "../../../utils/variables";
import Input from "../../master/Input";
import DatePicker from "../../master/DatePicker";
import SearchablePicker from "../../master/SearchablePicker";
import ExpertImage from "../ExpertImage";
import {getDirection, toast, validate} from "../../../utils/functions";
import { useTranslation } from 'react-i18next';

export default function UserData({data, changeData, uploadImage, changeStep, userType = 'culprit', lossesIndex = 0}) {

    const form = useRef(null);
    const imageForm = useRef(null);
    const { t, i18n } = useTranslation();
    const title = useMemo(() => userType === 'culprit' ? t('Culprit') : `${t('Losses')} ${t(latinAlphabet[lossesIndex])}`, [lossesIndex, userType]);
    const imageSuffix = useMemo(() => userType === 'losses' ? (Number(lossesIndex) + 1) : '', [lossesIndex, userType]);

    function nextStep() {
        const error = validate(form) + (validate(form) && validate(imageForm) && '،') + validate(imageForm);

        if (error) {
            // toast(`فیلد های اجباری ${error} را پر کنید.`, 'error');
            toast(t('Complete required fields',{err:error}), 'error');
            return;
        }
        changeStep(2);
    }

    return (
        <>
            <h4 className='mt20 text-center border-title'>{`${t('Driver info')} ${title}`}</h4>
            <div className={`row ${getDirection(i18n.language) ==='rightToLeft'? 'text-right': 'text-left'}`} ref={form}>
                <Input
                    label={t('Driver full name')}
                    value={data.driver_name}
                    required
                    onChange={value => changeData(value, 'driver_name')}
                />
                <Input
                    label={t('Driver national id')}
                    value={data.driver_national_id}
                    required
                    onChange={value => changeData(value, 'driver_national_id')}
                />
                <DatePicker
                    label={t('Birth date')}
                    isBirthDate
                    value={data.driver_birth_date}
                    required
                    onChange={date => changeData(date, 'driver_birth_date')}
                />
                {
                    // userType === 'losses' &&
                    (data.insurance_type === 'body' || (data.insurance_type === 'third' && userType !== 'culprit')) &&
                    <>
                        <Input
                            label={t('Shaba number')}
                            mode='numeric'
                            value={data.sheba}
                            onChange={value => changeData(value, 'sheba')}
                        />
                    </>
                }
                <SearchablePicker
                    label={t('License type')}
                    value={data.license_type || ''}
                    data={licenseTypes}
                    rtl={getDirection(i18n.language) ==='rightToLeft'}
                    required
                    onSelect={val => changeData(val, 'license_type')}
                    fixed={true}
                />
                {
                    data.license_type !== t('License less') &&
                    <Input
                        label={t('License number')}
                        value={data.license_number}
                        required
                        onChange={value => changeData(value, 'license_number')}
                    />
                }
            </div>
            <div className='gridParent' ref={imageForm}>
                <ExpertImage
                    title={t('License image')}
                    src={data.attachments.filter(itm => itm.filename.includes(`${userType}_license_image${imageSuffix}`))}
                    upload={(img, done) => uploadImage(img, `expert_${userType}_license_image${imageSuffix}`, done)}
                    label='license_image'
                    // required={!(userType === 'culprit' && data.insurance_type === 'third' && data.has_coroukie === 1)}
                />
                <ExpertImage
                    title={t('Back License image')}
                    src={data.attachments.filter(itm => itm.filename.includes(`${userType}_license_back_image${imageSuffix}`))}
                    upload={(img, done) => uploadImage(img, `expert_${userType}_license_back_image${imageSuffix}`, done)}
                    label='back_license_image'
                    // required={!(userType === 'culprit' && data.insurance_type === 'third' && data.has_coroukie === 1)}
                />
            </div>
            <div className='mt20 pr5 pl5'>
                <button
                    onClick={nextStep}
                    className='btn btn-green btn-block btn-circle'
                >
                   {t('Next step')}
                </button>
            </div>
        </>
    );
}
